import React from 'react';
import { Helmet } from 'react-helmet';

const TrackingScripts = ({ userEmail }) => {
  // This function will generate the correct ap3c script based on whether we have an email
  const getAp3cScript = () => {
    if (userEmail) {
      // If we have an email, we identify the user with it.
      // Ortto (ap3c) uses the 'e' property for the user's email.
      return `
        window.ap3c = window.ap3c || {};
        var ap3c = window.ap3c;
        ap3c.cmd = ap3c.cmd || [];
        ap3c.cmd.push(function() {
            ap3c.init('Zhb5rz6nlPEvEWOGbXBsb2k', 'https://cl.mploi.com/');
            ap3c.track({v: 0, email: '${userEmail}'});
        });
        ap3c.activity = function(act) { ap3c.act = (ap3c.act || []); ap3c.act.push(act); };
        var s, t; s = document.createElement('script'); s.type = 'text/javascript'; s.src = "https://cl.mploi.com/app.js";
        t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
      `;
    } else {
      // If there's no email, we use the original anonymous tracking script.
      return `
        window.ap3c = window.ap3c || {};
        var ap3c = window.ap3c;
        ap3c.cmd = ap3c.cmd || [];
        ap3c.cmd.push(function() {
            ap3c.init('Zhb5rz6nlPEvEWOGbXBsb2k', 'https://cl.mploi.com/');
            ap3c.track({v: 0});
        });
        ap3c.activity = function(act) { ap3c.act = (ap3c.act || []); ap3c.act.push(act); };
        var s, t; s = document.createElement('script'); s.type = 'text/javascript'; s.src = "https://cl.mploi.com/app.js";
        t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
      `;
    }
  };

  return (
    <Helmet>
      {/* --- Google Tag Manager Script --- */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-QTL64YWS2Y"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-QTL64YWS2Y');
        `}
      </script>

      {/* --- Your AP3C Tracking Script (now dynamically generated!) --- */}
      <script>
        {getAp3cScript()}
      </script>
    </Helmet>
  );
};

export default TrackingScripts;